<template>
  <div
    class="d-flex-row space-between height-max-content"
    v-if="selectedPlatform?.id"
  >
    <div class="d-flex-row justify-start flex-8">
      <img :src="selectedPlatform.image_dark" height="20" width="20" />
      <p
        class="t-white font-family-2 regular-l"
        style="text-transform: uppercase"
      >
        {{ selectedPlatform.title }}
      </p>
    </div>

    <p class="t-white font-family-2 bold-l caps">
      {{ renderPrice(selectedPlatform) }}
    </p>
  </div>
</template>

<script setup>
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();
const { currentGamePackSlug } = useGameComposable();

const selectedPlatform = computed(() => {
  if (!checkoutStore.getSelectedPlatform) return null;
  if (!gameStore.getGame.platforms) return null;
  const platform = gameStore.getGame.platforms?.find(
    (platform) => platform.id === checkoutStore.getSelectedPlatform
  );
  if (!platform?.id) return null;
  return platform;
});

const renderPrice = (packOption) => {
  // console.log(packOption);
  if (
    packOption?.title !== "PC" &&
    currentGamePackSlug === "marvel-rivals-one-above-all-boost"
  ) {
    return "-24%";
  }

  if (
    packOption?.title !== "PC" &&
    [
      "fc-coins-boost",
      "fc-fut-champions-final-boost",
      "fc-fut-champions-playoffs-boost",
      "fc-division-rivals-boost",
      "fc-division-rivals-wins-boost",
      "fc-squad-battles-boost",
      "fc-objectives-boost",
    ].includes(currentGamePackSlug)
  ) {
    return "+20%";
  }
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${handleCurrency(getUserCurrency)}`;
  } else {
    return `${userStore.getUserCurrencyCode}${parseFloat(
      packOption.price
    ).toFixed(2)}`;
  }
};
</script>
